<template>
  <div class="container">
    <div class="section">
      <title-bar v-if="apiProviders.length > 0" title="Integraciones API"/>
      <div v-if="apiProviders.length > 0" class="columns is-multiline">
        <div class="column is-3" v-for="api in apiProviders" :key="api.id">
          <div class="card">
            <h3>{{api.name}}</h3>
            <img src="@/assets/file-contractual.png" />
            <p>{{api.description}}</p>
            <button v-if="!api.credentials" class="button is-intelligential is-small">Conectar</button>
            <div v-else class="content-status"><span class="status"></span>Conectado</div>
          </div>
        </div>
      </div>
      <div
          v-else
          class="has-text-centered custom-empty-state"
        >
          <!-- Ícono -->
          <figure class="image  mb-6 is-inline-block">
            <img src="@/assets/empyState.svg" />
          </figure>

          <!-- Título -->
          <p class="has-text-weight-semibold is-size-5 mb-2">
            Aun no tienes integraciones activas
          </p>

          <!-- Subtítulo -->
          <p class="has-text-grey is-size-6">
            Explora nuestro marketplace de integraciones<br/>
            y activa las herramientas que necesitas
          </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '@/mixins/formats'
export default {
  components: {
    TitleBar: () => import('@/components/ui/TitleBar.vue')
  },
  mixins: [mixins],
  data () {
    return {
      loading: true,
      apiProviders: [
        // {
        //   id: 1,
        //   name: 'OCR INE',
        //   description: 'Obtener datos al cargar INE o pasaporte',
        //   credentials: null
        // }, {
        //   id: 2,
        //   name: 'OCR Comprobante de domicilio',
        //   description: 'Obtener datos del comprobante de domicilio (CFE, Telmex)',
        //   credentials: null
        // }, {
        //   id: 3,
        //   name: 'Validación de CURP',
        //   description: 'Validar CURP en la renapo',
        //   credentials: true
        // }, {
        //   id: 4,
        //   name: 'Obtención de NSS',
        //   description: 'Obtener NSS con el CURP',
        //   credentials: true
        // }, {
        //   id: 5,
        //   name: 'Buró de Crédito',
        //   description: 'Consulta en buró de Crédito',
        //   credentials: true
        // }, {
        //   id: 6,
        //   name: 'Círculo de crédito',
        //   description: 'Consulta en Círculo de crédito',
        //   credentials: null
        // }
      ]

    }
  },
  methods: {
    ...mapActions([])
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: (state) => state.financialCompany.financialCompany
    })
  },
  created () {

  }

}
</script>

<style lang="scss" scoped>
.section {
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.card {
  padding: 1.5rem 1rem;
  min-height: 300px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  h3 {
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }
  p {
    font-size: 12px;
    margin-bottom: 2rem;
  }
  img {
    width: 120px;
    align-self: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .button {
    background: #9c69ff !important;
  }
  .content-status {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    .status {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-right: 0.3rem;
      background: #21eb35;
      display: block;
    }
  }
}
.custom-empty-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
  img {
    width: 90px;
    height: auto;
  }
  p {
    margin-top: 1rem;
    text-align: center;
  }
}
</style>
